module.exports = __webpack_public_path__ + "img/setting_20.575a58df.svg";